import { createSlice } from "@reduxjs/toolkit";

const messageSlice = createSlice({
  name: "messageSlice",
  initialState: false,
  reducers: {
    setmessageSlice: (state, action) => {
      return action.payload;
    },
  },
});

export const { setmessageSlice } = messageSlice.actions;
export default messageSlice.reducer;
